import styled from 'styled-components';
import { StyleProps } from './OurOffer.interface';

export const GridWrapper = styled.div<StyleProps>`
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-top: ${({ theme }) => theme.spacing * 25}px;
    grid-column-gap: 16px;
    @media screen and (max-width: 690px) {
        margin-top: ${({ theme }) => theme.spacing * 10}px;
        grid-template-columns: 100%;
        grid-template-rows: repeat(2, auto);
        > div:first-child {
            grid-row: ${(props) => props.reverse && 2};
        }
    }
`;

export const FlexWrapper = styled.div`
    display: flex;
    flex-direction: row;
`;

export const ItemTitle = styled.h3`
    margin: 0;
    color: ${({ theme }) => theme.colors.gray};
    font-size: 18px;
    line-height: 40px;
    margin-bottom: ${({ theme }) => theme.spacing * 2}px;
    opacity: .87;
`;

export const ItemDescription = styled.p`
    margin: 0;
    color: ${({ theme }) => theme.colors.lightGrayAlpha};
    line-height: 30px;
    opacity: .87;
`;

export const ItemIcon = styled.div<StyleProps>`
    width: 40px;
    height: 40px;
    border-radius: 6px;
    margin-right: ${({ theme }) => theme.spacing * 4}px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${(props) => props.backgroundColor && props.backgroundColor};
    > svg {
        color: ${(props) => props.iconColor && props.iconColor};
        width:40px;
    }
`;

export const QuoteWrapper = styled.div<StyleProps>`
    width: 400px;
    display: grid;
    grid-template-columns: 30px auto;
    padding: ${({ theme }) => theme.spacing * 4}px 
        ${({ theme }) => theme.spacing * 6}px;
    box-sizing: border-box;
    border-radius: 6px;
    background-color: ${({ theme}) => theme.colors.paleBlue};
    margin-top: ${({ theme }) => theme.spacing * 4}px;
    > svg {
        color: ${(props) => props.iconColor && props.iconColor};
    }
    > div {
        > p {
            margin: 0;
            font-size: 12px;
            font-style: italic;
            line-height: 21px;
            color: ${({ theme }) => theme.colors.grayAlpha};
            opacity: .87;
        }
        > h3 {
            margin: 0;
            font-size: 12px; 
            line-height: 21px;
            color: ${({ theme }) => theme.colors.gray};
            opacity: .87;
        }
    }
    @media screen and (max-width: 690px) {
        width: 100%;
    }
`;

export const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 40px auto;
    grid-column-gap: ${({ theme }) => theme.spacing * 4}px;
`;

export const Image = styled.div<StyleProps>`
    margin-top: ${({ theme}) => theme.spacing * 2}px;
    display: flex;
    justify-content: ${(props) => props.align && props.align};
    @media screen and (max-width: 690px) {
        width: 100%;
        margin: ${({ theme}) => theme.spacing * 6}px 0
            ${({ theme}) => theme.spacing * 4}px;
    }
`;

export const SmallBannerWrapper = styled.div`
    position: relative;
    width: 340px;
    height: 320px;
    @media screen and (max-width: 690px) {
        width: 100%;
    }
    > img {
        width: 280px;
        height: auto;
        position: absolute;
        box-shadow: 0 20px 30px 0 ${({ theme }) => theme.colors.blackAlpha};
        @media screen and (max-width: 690px) {
            width: 80%;
        }
    }
    > img:first-child {
        top: 0;
        right: 0;
    }
    > img:last-child {
        bottom: 0;
        left: 0;
        z-index: 100;
    }
`;

export const BigBannerWrapper = styled.div`
    position: relative;
    width: 380px;
    height: 80px;
    @media screen and (max-width: 690px) {
        width: 100%;
        height: 60px;
    }
    > img {
        width: 360px;
        height: auto;
        position: absolute;
        box-shadow: 0 20px 30px 0 ${({ theme }) => theme.colors.blackAlpha};
        @media screen and (max-width: 690px) {
            width: 80%;
        }
    }
    > img:first-child {
        top: 0;
        left: 0;
    }
    > img:last-child {
        bottom: 0;
        right: 0;
        z-index: 100;
    }
`;

export const VideoBannerWrapper = styled.div`
    position: relative;
    width: 400px;
    height: 300px;
    @media screen and (max-width: 690px) {
        width: 100%;
        height: 250px;
    }
    > img {
        width: 360px;
        height: auto;
        position: absolute;
        box-shadow: 0 20px 30px 0 ${({ theme }) => theme.colors.blackAlpha};
        @media screen and (max-width: 690px) {
            width: 80%;
        }
    }
    > img:first-child {
        top: 0;
        right: 0;
    }
    > img:last-child {
        bottom: 0;
        left: 0;
        z-index: 100;
    }
`;

export const PollBannerWrapper = styled.div`
    position: relative;
    width: 290px;
    height: 380px;
    @media screen and (max-width: 690px) {
        width: 100%;
    }
    > img {
        width: 220px;
        height: auto;
        position: absolute;
        box-shadow: 0 20px 30px 0 ${({ theme }) => theme.colors.blackAlpha};
        @media screen and (max-width: 690px) {
            width: 80%;
        }
    }
    > img:first-child {
        top: 0;
        left: 0;
    }
    > img:last-child {
        bottom: 0;
        right: 0;
        z-index: 100;
    }
`;
